import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useModal } from 'Store/modal';

const useHandleCancel = () => {
  const { t } = useTranslation('user');
  const navigate = useNavigate();
  const { onOpenModal, onResetModal } = useModal();

  const handleClickCancel = () => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('cancelEditTitle'),
      contentDescription: t('cancelEditDescription'),
      showPrimaryButton: true,
      primaryButtonText: t('cancelEditSubmitButton'),
      showSecondaryButton: true,
      secondaryButtonText: t('cancelEditCancelButton'),
      onClickPrimaryButton: () => {
        onResetModal();
        navigate(-1);
      },
    });
  };

  return { handleClickCancel };
};

export default useHandleCancel;